module.exports = __webpack_public_path__ + "img/S.6798d85c.png";